import { render, staticRenderFns } from "./StoragePR_detail.vue?vue&type=template&id=cfe92524&scoped=true&"
import script from "./StoragePR_detail.vue?vue&type=script&lang=js&"
export * from "./StoragePR_detail.vue?vue&type=script&lang=js&"
import style0 from "./StoragePR_detail.vue?vue&type=style&index=0&id=cfe92524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe92524",
  null
  
)

export default component.exports